// Query keys shared by more than one surface.
//
// The public campaign feed is read in two places - the promotions page
// (pages/Others/Promotion) and the lobby's promo carousel
// (views/Games/lobby/PromoCarousel) - so they must use the *same* key, or one
// invalidation refreshes only one of them and the other keeps showing a
// campaign's old banner for the rest of the cache window.
// Invalidated centrally by hooks/usePromotionCampaignSync.
export const PROMOTION_CAMPAIGNS_QUERY_KEY = ["promotion-campaigns"];

// Account completeness (DOB, country, terms, email): the completion dialog and the verify-email page.
export const ACCOUNT_STATUS_QUERY_KEY = ["account-status"];
export const PASSWORD_STATUS_QUERY_KEY = ["password-status"];

// The caller's IP country and blocks: the visit popup, sign-up, helplines and the fingerprint skip.
export const GEO_STATUS_QUERY_KEY = ["auth-geo"];
export const SHOW_CURRENCY_OPTIONS_QUERY_KEY = ["currency-show-options"];
